import { ChangeDetectionStrategy, Component, Input, OnInit, inject } from '@angular/core';

import { Observable, map, distinctUntilChanged } from 'rxjs';
import { Store } from '@ngrx/store';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles';

import { FinnairAmount } from '@fcom/dapi/api/models';
import { AppState } from '@fcom/core/interfaces';
import { pseudoLocal } from '@fcom/core/selectors';

@Component({
  selector: 'fin-total-expand',
  templateUrl: './total-expand.component.html',
  styleUrls: ['./total-expand.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TotalExpandComponent implements OnInit {
  private store$ = inject<Store<AppState>>(Store);

  readonly SvgLibraryIcon = SvgLibraryIcon;

  @Input()
  expandId: string;

  @Input()
  total$: Observable<FinnairAmount>;

  @Input()
  initiallyOpen = false;

  @Input()
  loading$: Observable<boolean>;

  @Input()
  totalTranslationKey$: Observable<string>;

  @Input()
  titleTranslationKey: string;

  @Input()
  expandButtonAriaLabelKey: string;

  isOpen$: Observable<boolean>;

  ngOnInit(): void {
    // proxy the child state here for testability
    this.isOpen$ = this.store$.pipe(pseudoLocal(this.expandId), map(Boolean), distinctUntilChanged());
  }
}
